module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/vegamagic.6ed335f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/vegamagic.jpg
// module id = 6JJp
// module chunks = 0